import { useEffect, useState } from 'react';
import { ClipboardList, Package } from 'lucide-react';
import { fetchStaffSiteLinks } from '../api/staff.js';

function StockIcon() {
  return (
    <div
      className="relative flex h-36 w-36 items-center justify-center rounded-full bg-rose-200 shadow-md"
      aria-hidden="true"
    >
      <div className="relative flex flex-col items-center">
        <ClipboardList
          className="absolute -top-7 left-1/2 h-10 w-10 -translate-x-1/2 text-slate-800"
          strokeWidth={1.75}
        />
        <Package className="relative z-10 h-14 w-14 text-slate-800" strokeWidth={1.75} />
        <div className="mt-1 flex gap-0.5">
          <span className="h-2 w-5 rounded-sm border-2 border-slate-800 bg-white" />
          <span className="h-2.5 w-6 rounded-sm border-2 border-slate-800 bg-white" />
          <span className="h-2 w-5 rounded-sm border-2 border-slate-800 bg-white" />
        </div>
        <div className="mt-0.5 h-1 w-16 rounded-sm bg-slate-800" />
      </div>
    </div>
  );
}

function Stock() {
  const [stockTrackerUrl, setStockTrackerUrl] = useState(null);

  useEffect(() => {
    let cancelled = false;
    void fetchStaffSiteLinks().then((links) => {
      if (cancelled || !links.ok) return;
      setStockTrackerUrl(links.stockTrackerUrl);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="flex min-h-[calc(100dvh-8.5rem)] flex-col items-center justify-center px-6 py-8 text-center">
      <StockIcon />

      <p className="mt-8 max-w-xs text-base leading-relaxed text-slate-700">
        Please record how many stocks you take and return to distributor here:
      </p>

      {stockTrackerUrl ? (
        <a
          href={stockTrackerUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 text-lg font-bold text-slate-900 underline decoration-2 underline-offset-4 transition hover:text-brand-accent"
        >
          Tap here
        </a>
      ) : (
        <span className="mt-4 text-lg font-bold text-slate-400">Tap here</span>
      )}
    </div>
  );
}

export default Stock;
